var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from "react";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { useNavigate, useParams } from "react-router-dom";
import { quotesRoutes } from "@frameworks/web/components/features/Quotes/constant";
import Drawer from "react-bottom-drawer";
import VsComponent from "@frameworks/web/components/features/Quotes/Common/PeerComparision/VsComponent";
var CheckedListViewAll = function (props) {
    var device = DeviceContext();
    var _a = __read(useState(false), 2), isDrawerOpen = _a[0], setIsDrawerOpen = _a[1];
    var symbol = useParams().symbol;
    var navigate = useNavigate();
    var handleCompareClick = function () {
        if (device === null || device === void 0 ? void 0 : device.isDesktop) {
            compareNavigate();
        }
        else {
            setIsDrawerOpen(true);
        }
    };
    var compareNavigate = function () {
        var _a;
        var compareList = __spreadArray(__spreadArray([], __read((_a = props === null || props === void 0 ? void 0 : props.checked) === null || _a === void 0 ? void 0 : _a.map(function (el) { return el === null || el === void 0 ? void 0 : el.schemeCode; })), false), __read((symbol ? [symbol] : [])), false);
        window.sessionStorage.setItem("compareList", JSON.stringify(compareList));
        var checkedList = __spreadArray(__spreadArray([], __read(props.currentItem), false), __read(props.checked), false);
        navigate(quotesRoutes.Q_PEER_Compare, {
            state: {
                checkedList: checkedList,
                page: props.page,
                redirectionUrl: props === null || props === void 0 ? void 0 : props.redirectionUrl,
                paramsData: props === null || props === void 0 ? void 0 : props.paramsData,
            },
        });
    };
    var renderFundItem = function (ele, idx, isCurrent) {
        if (isCurrent === void 0) { isCurrent = false; }
        return (React.createElement("div", { key: idx, className: "d-flex align-items-center checked-list bg_aqua_white" },
            React.createElement("label", { className: "DMSan_14_500 bg_white d-flex align-items-center", key: idx },
                props.page === "mutualFunds" ||
                    props.page === "indexFunds" ||
                    props.page === "etf"
                    ? ele.schemeName
                    : ele.name,
                React.createElement("i", { className: "edel-icon-trash txt_bloodRed", onClick: function () {
                        props.setCurrentItem([]);
                    } }))));
    };
    var renderFundItemMob = function (ele, idx, isCurrent, totalCount) { return (React.createElement("div", { key: idx },
        React.createElement("div", { className: "d-flex align-items-center justify-content-between checked-list compare-mob-drawer px-15" },
            React.createElement("div", { className: "DMSan_14_500 bg_white d-flex align-items-center gap-5-custom" },
                React.createElement("span", { className: "edel-icon-move txt_secondary-gray" }),
                React.createElement("span", null,
                    " ",
                    props.page === "mutualFunds" ||
                        props.page === "indexFunds" ||
                        props.page === "etf"
                        ? ele.schemeName
                        : ele.name)),
            React.createElement("i", { className: "edel-icon-cross", onClick: function () {
                    if (isCurrent) {
                        props.setCurrentItem([]);
                    }
                    else {
                        props.setChecked(props.checked.filter(function (el) { return el.schemeCode !== ele.schemeCode; }));
                    }
                } })),
        idx < totalCount - 1 && (React.createElement("div", { onClick: function () { return totalCount === 2 && setIsDrawerOpen(false); } },
            React.createElement("div", { className: "vscomponent-mobile" },
                React.createElement(VsComponent, null)))))); };
    var renderEmptyFundSlot = function () { return (React.createElement(React.Fragment, null,
        " ",
        React.createElement("div", { className: "d-flex align-items-center justify-content-center checked-list compare-add-mob-drawer px-15", onClick: function () {
                return props.addMore ? props.addMore() : setIsDrawerOpen(false);
            } },
            React.createElement("div", { className: "DMSan_14_500 txt_blackOne1" }, "+ Add 1 More ")))); };
    var totalSelectedFunds = props.checked.length + ((props === null || props === void 0 ? void 0 : props.isMarketPage) === true ? 0 : 1);
    return (React.createElement(React.Fragment, null,
        (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement("div", { className: "bg_aqua_white compare-funds" },
            React.createElement(GridContainer, { parentClass: "compare-clear" },
                React.createElement("div", { className: "d-flex align-items-center checked-block" },
                    React.createElement("label", { className: "DMSan_14_700 txt_blackOne1" },
                        props.checked.length + ((props === null || props === void 0 ? void 0 : props.isMarketPage) === true ? 0 : 1),
                        " ",
                        "Fund Selected",
                        " "),
                    React.createElement("div", { className: "d-flex align-items-center" },
                        props.currentItem.map(function (ele, idx) {
                            return renderFundItem(ele, idx, true);
                        }),
                        props.checked.map(function (ele, idx) { return renderFundItem(ele, idx); }),
                        totalSelectedFunds < 3 && renderEmptyFundSlot())),
                React.createElement("div", { className: "compare-clear-buttons d-flex align-items-center" },
                    React.createElement("div", { className: "compare-button d-flex align-items-center bg-midnight-blue" },
                        React.createElement("i", { className: "edel-icon-compare txt_white" }),
                        React.createElement("button", { onClick: handleCompareClick },
                            "Compare (",
                            totalSelectedFunds,
                            "/3)")),
                    React.createElement(EdButton, { btnTyp: "link", value: "Clear All", className: "no_bg DMSansMedium_16_500", onClick: function () {
                            props.setChecked([]);
                            props.close();
                        } }))))) : (React.createElement("div", { className: "compare-button d-flex align-items-center bg-midnight-blue" },
            React.createElement("i", { className: "edel-icon-compare txt_white" }),
            React.createElement("button", { onClick: handleCompareClick },
                "Compare (",
                props.checked.length + ((props === null || props === void 0 ? void 0 : props.isMarketPage) === true ? 0 : 1),
                "/3)"))),
        React.createElement("div", { className: "z-index-high mb-genericSidebar" },
            React.createElement(Drawer, { className: "z-index-high backgroundcolor_bluedrawer", hideScrollbars: true, isVisible: isDrawerOpen, onClose: function () { return setIsDrawerOpen(false); } },
                React.createElement("div", { className: "drawer-head bg_aqua_white DMSan_16_500 px-15 pdt-20 pb-10 mb-20" },
                    "Compare Funds",
                    React.createElement("div", { className: "DMSanM_14_500 txt-Primary-gray mgt-5" },
                        "Selected ",
                        totalSelectedFunds,
                        "/3 stocks to compare")),
                React.createElement("div", { className: "drawer-body bg_white" },
                    props.currentItem.map(function (ele, idx) {
                        return renderFundItemMob(ele, idx, true, totalSelectedFunds);
                    }),
                    props.checked.map(function (ele, idx) {
                        return renderFundItemMob(ele, idx + props.currentItem.length, false, totalSelectedFunds);
                    }),
                    totalSelectedFunds < 3 && renderEmptyFundSlot()),
                React.createElement("div", { className: "drawer-footer p-2" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: React.createElement("div", { className: " d-flex align-items-center bg-midnight-blue justify-content-center gap-10" },
                            React.createElement("i", { className: "edel-icon-compare txt_white" }),
                            React.createElement("div", { className: "DMSan_14_500 txt_white" }, "Compare Now")), onClick: function () {
                            setIsDrawerOpen(false);
                            compareNavigate();
                        }, className: "btn btn-primary w-100" }))))));
};
export default CheckedListViewAll;
